import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyMonogramLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/monogram" */ './Monogram'), 'MonogramLayout');
